module.exports = __webpack_public_path__ + "img/nova-brasil.bcb5f719.png";